﻿import { useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid';
import '../Components/MarketingSection.scss';
import { fetchSignedURL } from '../../../api/file';

export default function MarketingSection({ header, text }) {
  function createMarkup() {
    return {
      __html: text,
    };
  }

  const containerRef = useRef(null);
  useEffect(() => {
    const handleClick = (event) => {
      const link = event.target.closest('li a');
      if (link && containerRef.current.contains(link)) {
        event.preventDefault();
        event.stopPropagation();

        // parse href of marketing section link to see if it is a file link or regular external
        if (link.href.includes('agentportal.baltlife.com')) {
          const filePath = link.pathname;
          fetchSignedURL(filePath);
        } else {
          window.open(link.href, '_blank');
          return;
        }
      }
    };

    const container = containerRef.current;
    container?.addEventListener('click', handleClick);

    return () => {
      container?.removeEventListener('click', handleClick);
    };
  }, [text]);

  /*  <div dangerouslySetInnerHTML={createMarkup()} /> */

  return (
    <>
      {text != '<p></p>' &&
        text != '<p></p>\n' && ( //check for empty paragraph
          <>
            <Grid className="marketingSub-header" size={12}>
              <h3>{header}</h3>
            </Grid>
            <Grid size={12}>
              {/*text*/}
              <div
                ref={containerRef}
                className="marketingContent"
                dangerouslySetInnerHTML={createMarkup()}
              />
            </Grid>
          </>
        )}
    </>
  );
}
